import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {Link} from '@modifi/router'
import {ButtonPrimary} from '@modifi/ui'
import {useTranslation} from '@modifi/plugin-i18n'
import {SignUpButtonActualItem, SignUpButtonNavItem} from './styles'
import {NavItem} from '../../styles'

const propTypes = {
  isHamburger: PropTypes.bool,
  signUpUrl: PropTypes.string,
  handleNavItemClick: PropTypes.func,
}
const defaultProps = {
  isHamburger: false,
  signUpUrl: undefined,
  handleNavItemClick: () => null,
}

export type SignUpButtonProps = InferPropTypes<typeof propTypes, typeof defaultProps>

const SignUpButton: React.FC<SignUpButtonProps> = ({
  isHamburger,
  signUpUrl,
  handleNavItemClick,
}) => {
  const {t} = useTranslation('janus')

  if (!signUpUrl) {
    return null
  }

  if (!isHamburger) {
    return (
      <NavItem>
        <SignUpButtonActualItem>
          <Link to={signUpUrl} scrollToTop>
            <ButtonPrimary data-target="sign-up">{t('sitemap.sign-up')}</ButtonPrimary>
          </Link>
        </SignUpButtonActualItem>
      </NavItem>
    )
  }

  return (
    <SignUpButtonNavItem isHamburger={isHamburger ?? false}>
      <Link to={signUpUrl} scrollToTop onClick={handleNavItemClick}>
        <ButtonPrimary data-target="sign-up">{t('sitemap.sign-up')}</ButtonPrimary>
      </Link>
    </SignUpButtonNavItem>
  )
}

SignUpButton.propTypes = propTypes
SignUpButton.defaultProps = defaultProps

export default SignUpButton
